export const tipoComprobantes = [
  { Codigo: 'INGRESO', Descripcion: 'Ingreso' },
  { Codigo: 'EGRESO', Descripcion: 'Egreso' },
  { Codigo: 'TRANSFERENCIA', Descripcion: 'Transferencia' },
];

export const tipoMovimientos = [
  { Codigo: 'ALTA', Descripcion: 'Alta' },
  { Codigo: 'BAJA', Descripcion: 'Baja' },
];
